import { FC } from 'react'
import { PacksWelcome } from '@loadedhub/team-onboarding-management'
import TeamOnboardingWidgetProvider from '../../_common/components/TeamOnboardingWidgetProvider'

/** Help content for the Onboarding Packs page - the onboarding welcome intro. */
const OnboardingPacksHelpContent: FC = () => (
  <TeamOnboardingWidgetProvider>
    <PacksWelcome />
  </TeamOnboardingWidgetProvider>
)

export default OnboardingPacksHelpContent
